import type { ReactNode } from 'react';

export const symbol_folder_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M880-680v429q0 15-9.32 22.5t-20.5 7.5q-11.18 0-20.68-7.68-9.5-7.69-9.5-22.32v-429H451q-12.44 0-23.72-5t-19.5-13.22L357-749q-11-11-9.5-22.5T357-791q8-8 20.07-9.5t22.63 9.72L451-740h369q23 0 41.5 18.5T880-680ZM140-160q-24 0-42-18.5T80-220v-520q0-23 18-41.5t42-18.5h34l60 60h-94v520h530L77-813q-9-9-9-21t9-21q9-9 21-9t21 9L883-91q9 9 9 21t-9 21.39Q874-40 862-40t-21-9L730-160H140Zm270-320Zm160-10Z"
		/>
	</svg>
);
